import React, { useState, CSSProperties, useEffect, useRef } from 'react'
import '../Css/Interview_link.css'
import camera_icon from '../assets/Camera icon.png'
import Primary_Button from '../Components/Primary_Button';
import { ToastContainer, toast, Bounce } from 'react-toastify';
import { RiseLoader } from "react-spinners"
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { setAccessToken, setCurrentQuestionId, setInterviewId, setInterviewKey, setQuestionCount } from '../Redux/UserSlice';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import InterviewGuidelines from '../Components/InterviewGuidelines';
import posthog from 'posthog-js';
import Loader from '../Components/Loader';
import CameraDisplay from '../Components/CameraDisplay';
import DraggableCamera from '../Components/CameraDisplay';
import addMetadataWithFFmpeg from '../Components/addMetadataWithFFmpeg';

function Interview_link() {
    const [isCameraEnabled, setIsCameraEnabled] = useState(false);

    const [interviewLink, setInterviewLink] = useState("");
    const [loading, setLoading] = useState(false);
    const [loadingText, setLoadingText] = useState();
    const interviewKey = useSelector((state) => state.User.interviewKey)
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        // // console.log(interviewKey);
        const params = new URLSearchParams(window.location.search);
        const key = params.get('interview_key');
        if (key) {
            setInterviewLink(key);
            // console.log('Interview Key:', key); // optional
        }
        if (interviewKey) {
            navigate('/interview-questions')
        }
    }, [])

    const handleStartInterview = async () => {
        if (!interviewLink) {
            document.getElementsByName('interview_link_input')[0].style.borderColor = "red";
            toast.error('Please Enter Interview Link');
            return;
        } else {
            document.getElementsByName('interview_link_input')[0].style.borderColor = "#a8a8a8";
        }

        // console.log(interviewLink)
        setLoading(true)
        setLoadingText("Generating interview questions... This may take up to 2 minutes. Please stay on this page and do not close or switch tabs.")
        try {
            let res = await fetch(`${process.env.REACT_APP_API_URL}/v2/create_interview?interview_link=${interviewLink}`, {
                method: "GET",
                headers: {
                    accept: "application/json"
                }
            });
            const data = await res?.json();
            if (!res.ok) {
                throw new Error(data?.detail || 'Failed to create interview');
            }
            // console.log(data);
            dispatch(setQuestionCount({ isNewInterview: true }));
            dispatch(setInterviewId(data.interview_id));
            dispatch(setInterviewKey(interviewLink));
            // // console.log(data);

            handleSessionLink(data.interview_id);

        } catch (error) {
            document.getElementsByName('interview_link_input')[0].style.borderColor = "red";
            // console.log(error);
            toast.error(error?.message);
            setLoading(false);
        }
    }

    const handleSessionLink = async (interview_id) => {
        try {
            let sessionUrl = posthog.get_session_replay_url({ withTimestamp: true })
            let reqBody = new FormData();
            reqBody?.append("session_url", sessionUrl?.toString());
            // console.log(sessionUrl);

            const res = await fetch(`${process.env.REACT_APP_API_URL}/v2/add_session_reply_url?interview_id=${interview_id}`, {
                method: "POST",
                body: reqBody
            });
            const data = await res.json();
            // console.log(data);
            if (!res.ok) {
                throw new Error(data?.detail || 'Failed to save session link');
            }
            // console.log("Session link saved");
            navigate('/interview-questions');
        } catch (error) {
            // console.log("Error in handleSessionLink: ", error);
            // console.log("Error Message in handleSessionLink: ", error?.message);
            toast.error(error?.message);
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <Loader loading={loading} message={loadingText} />
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
                transition={Bounce}
            />
            <div className="interview_link_body_container">
                <div className="page_header">
                    <p>PRELIMINARY INTERVIEW</p>
                </div>
                <div className="interview_link_inputbox_container">
                    <div className="interview_link_inputbox_header">
                        Enter your interview key
                    </div>
                    <div className="interview_link_input_container">
                        <label htmlFor="interview_link_input">Interview key</label>
                        <input type="text" value={interviewLink} onChange={(e) => { setInterviewLink(e.target.value) }} name="interview_link_input" id="" placeholder='Enter Interview key here' />
                        <p>Paste or type the interview key provided to you</p>
                    </div>
                    <div className="start_interview_btn_container">
                        <div className="start_interview_btn" onClick={interviewLink ? () => { handleStartInterview() } : null}>
                            {
                                interviewLink ?
                                    <Primary_Button
                                        widthProp="130px"
                                        borderRadiusProp="7px"
                                        fontWeightProp="600"
                                        fontSizeProp="16px"
                                        paddingProp="12px 0px 14px 0px"
                                        textProp="Start Interview" />
                                    :
                                    <Primary_Button
                                        widthProp="130px"
                                        borderRadiusProp="7px"
                                        fontWeightProp="600"
                                        fontSizeProp="16px"
                                        paddingProp="12px 0px 14px 0px"
                                        textProp="Start Interview"
                                        cursorProp='initial'
                                        bgColorProp="grey" />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Interview_link
